import formFieldCommonOptions from 'foundation/js/formFieldCommonOptions'
import cprValidator from 'foundation/js/inputValidators/cprValidator'

const options = formFieldCommonOptions('FormInputCprField', {
    validatorFunction(input) {
        return cprValidator(input)
    }
})

export default options
